// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popcorn-video[data-v-332824ce] {\n  max-width: 600px;\n}\n.popcorn-explainer-content[data-v-332824ce] {\n  max-width: 500px;\n}\nul[data-v-332824ce] {\n  list-style: none;\n  padding: 0;\n}\n.li-icon[data-v-332824ce] {\n  height: 2rem;\n  width: auto;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
